import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <section className="fade-up text-center">
      <h1 className="neon-text text-4xl font-bold">404</h1>
      <p className="mt-2 text-slate-400">페이지를 찾을 수 없습니다.</p>
      <Link to="/" className="btn-neon mt-6 inline-block rounded-lg px-4 py-2 text-sm">
        홈으로
      </Link>
    </section>
  );
}
